import { IApplicationState } from '../../types/redux';
import { IGetEstimationSaleWebRequest } from '../../repositories/price-estimator/v1/get-estimation-sale-web';
import { IGetEstimationRentWebRequest } from '../../repositories/price-estimator/v1/get-estimation-rent-web';
import { selectMappedPreciseFilters } from '../preciseFilters';
import { selectEstimationId, selectOfferId } from '../page';
import { IGetEstimationSuburbanRequest } from '../../repositories/price-estimator/v1/get-estimation-suburban';
import { ECategory } from '../../repositories/price-estimator/entities/estimation_suburban/EstimationSuburbanRequestSchema';

export type TReturn = IGetEstimationSaleWebRequest & IGetEstimationRentWebRequest;

/** Возвращает необходимые параметры для апи оценки по продаже и аренде, хранящиеся в сторе */
export const selectApiParameters = (state: IApplicationState): TReturn => ({
  address: state.filters.address,
  area: state.filters.area as number,
  roomsCount: state.filters.roomsCount as number,
  filters: selectMappedPreciseFilters(state),
  offerId: selectOfferId(state),
  estimationId: selectEstimationId(state),
});

export const selectSuburbanApiParameters = (state: IApplicationState): IGetEstimationSuburbanRequest => ({
  address: state.filters.address,
  landArea: state.filters.landArea as number,
  houseArea: state.filters.houseArea,
  estimationId: selectEstimationId(state),
  category: state.filters.category as unknown as ECategory,
  filters: selectMappedPreciseFilters(state),
  lat: state.page.queryParams.lat,
  lng: state.page.queryParams.lng,
});
